var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 4.83133C44.3073 5.65074 42.4885 6.20454 40.5795 6.45368C42.5283 5.17856 44.0245 3.15935 44.7291 0.753498C42.8766 1.95365 40.8498 2.79924 38.7363 3.25371C37.0147 1.25138 34.5622 0 31.8476 0C26.6356 0 22.4099 4.61319 22.4099 10.303C22.4099 11.1106 22.4935 11.8969 22.6543 12.6511C14.8109 12.2213 7.85702 8.11957 3.20221 1.886C2.39002 3.40771 1.92463 5.17777 1.92463 7.06573C1.92463 10.6404 3.59088 13.7939 6.12303 15.6416C4.62435 15.5904 3.15863 15.1484 1.84827 14.3527C1.84773 14.3959 1.84773 14.4391 1.84773 14.4824C1.84773 19.4744 5.10079 23.6388 9.41796 24.5853C8.02823 24.9979 6.57051 25.0583 5.15613 24.7618C6.35698 28.8552 9.84238 31.8339 13.972 31.9172C10.7421 34.6805 6.6727 36.3278 2.2513 36.3278C1.48943 36.3278 0.738336 36.2789 0 36.1838C4.17648 39.1071 9.13711 40.8129 14.4666 40.8129C31.8257 40.8129 41.3181 25.113 41.3181 11.4979C41.3181 11.051 41.3091 10.6066 41.2908 10.1649C43.1384 8.70668 44.7331 6.90058 46 4.83133Z",
    fill: "#55ACEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a75ae03e8f606c4ee264654e803a23bb.svg";
export { ForwardRef as ReactComponent };